module.exports = __webpack_public_path__ + "img/MCP_pic_01.e963fde9.png";